import { useRef, useState } from "react";
import { Waypoint } from 'react-waypoint';

import { allMediaMutedSelector, setAllVideosMuted } from "../../app/recipePage/recipePage.slice";
import { useAppDispatch, useAppSelector } from "../../app/store/hooks";
import trimCloudinaryVideo from "../../utils/images/cloudinaryUtil";
import styles from "./mediaPlayer.module.css";
import ToggleSoundIcon from "./ToggleSoundIcon";

const RecipeStepMedia = ({
    url,
    muted = true,
    duration,
    startTime,
    loop = false,
}: {
    url: string,
    muted: boolean,
    duration: number,
    startTime: number,
    loop: boolean,
}) => {
    const player = useRef<HTMLVideoElement | null>(null);
    const config = { startTime, duration, quality: "low" };
    const [playing, setPlaying] = useState(false);
    const dispatch = useAppDispatch();
    const allMediaMuted = useAppSelector(allMediaMutedSelector);

    const handleVideoPress = () => {
        if (playing && player.current) {
            player.current.pause();
            setPlaying(false);
        } else {
            player.current ? player.current.play() : null;
            setPlaying(true);
        }
    };

    const onVideoTap = () => {
        if (!allMediaMuted || !muted) {
            dispatch(setAllVideosMuted(!allMediaMuted));
        }
    }

    if (!url) return null;

    return (
        <div className={styles.wrapper} id="media-player" onClick={onVideoTap} >
            <Waypoint
                bottomOffset="30%"
                onEnter={handleVideoPress}
                onLeave={handleVideoPress}
                topOffset="30%"
            >
                <video
                    className={`${styles.video_container} react-player`}
                    id="recipe-substep-media"
                    loop={loop}
                    muted={allMediaMuted || muted}
                    playsInline
                    preload="none"
                    ref={player}
                >
                    <source src={trimCloudinaryVideo(url, config)} type="video/webm" />
                </video >
            </Waypoint>
            <div className={styles.icon_container} id="toggle-media-sound-container">
                {!muted && <ToggleSoundIcon />}
            </div>
        </div>
    );
};

export default RecipeStepMedia;
